import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { adminSaga, USER_LOGOUT, adminReducer } from 'react-admin';
import thunk from 'redux-thunk';
import {
  authProvider,
  authReducer,
  settingsReducer,
  getBase,
  getBaseWithRoot,
  combinedSagas,
} from './ReactAdminOss._Core/src';

const createAdminStore = (history, dataProvider, useReduxDevTools, reducers) => {
  const reducer = combineReducers({
    admin: adminReducer,
    auth: authReducer,
    settings: settingsReducer({
      authorizationApi: `${process.env.REACT_APP_AUTHORIZATION_API}`,
      loginCallback: `${getBaseWithRoot(process.env.REACT_APP_BASENAME)}/callback`,
      logoutCallback: `${getBase()}`,
      clientId: `${process.env.REACT_APP_CLIENT_ID}`,
      ssoUrl: `${process.env.REACT_APP_OSS_PATH}/bbs2`,
      ssoRedirectUrl:
        process.env.REACT_APP_DEPLOYED_URL && `${process.env.REACT_APP_DEPLOYED_URL}/close-window`,
    }),
    ...reducers,
    router: connectRouter(history),
  });

  const resettableAppReducer = (state, action) =>
    reducer(action.type !== USER_LOGOUT ? state : undefined, action);

  const saga = function* rootSaga() {
    yield all(
      [
        adminSaga(dataProvider, authProvider),
        // add your own sagas here
        combinedSagas,
      ].map(fork)
    );
  };
  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers =
    (process.env.NODE_ENV === 'development' &&
      useReduxDevTools &&
      typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })) ||
    compose;

  const store = createStore(
    resettableAppReducer,
    {
      /* set your initial state here */
    },
    composeEnhancers(
      applyMiddleware(
        sagaMiddleware,
        routerMiddleware(history),
        thunk
        // add your own middlewares here
      )
      // add your own enhancers here
    )
  );

  sagaMiddleware.run(saga);
  return store;
};

export default createAdminStore;
